export default "__VITE_ASSET__BVc6sLVE__ 1200w";